import React, { Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
//import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
//import leaderboardData from "./json/npsalltimeranking/leaderboard.json"
//import PrivacyPloicy from "./pages/PrivacyPolicyNew/PrivacyPloicy";
import NewFaq from "./pages/NewFaq/NewFaq";
import Faq from "./pages/Faq/Faq";
import Legal from "./pages/Faq/Legal";
import Tnc from "./pages/Faq/Tnc";
import PrivacyPolicy from "./pages/Faq/PrivacyPolicy";
import GeneralQueries, {
  BaaziSelectMembership,
  BaaziStore,
  GameplayQueries,
  LeaderboardAndProgression,
  TaskRewards,
  TechnicalQueries,
  Wallet,
} from "./pages/Faq/GeneralQueries";
import Rewardpoints from "./pages/Faq/Rewardpoints";
import CoinDetailsNew from "./pages/CoinDetailsNew/CoinDetailsNew";
import TournamentRules from "./pages/TournamentRules";
import NotFound from "./pages/NotFound/NotFound";

import EN from "./en/EN";
import PH from "./ph/PH";
import PHNewFaq from "./ph/NewFaq/NewFaq";
import PHCoinsDetail from "./ph/CoinDetailsNew/CoinDetailsNew";

import PHFaq from "./ph/Faq/Faq";
import PHLegal from "./ph/Faq/Legal";
import PHTnc from "./ph/Faq/Tnc";
import PHPrivacyPolicy from "./ph/Faq/PrivacyPolicy";
import PHRewardpoints from "./ph/Faq/Rewardpoints";
import PHGeneralQueries, {
  PHBaaziSelectMembership,
  PHBaaziStore,
  PHGameplayQueries,
  PHLeaderboardAndProgression,
  PHTaskRewards,
  PHTechnicalQueries,
  PHWallet,
} from "./ph/Faq/GeneralQueries";
import PHTournamentRules from "./ph/TournamentRules";

import ES from "./es/ES";
import ESNewFaq from "./es/NewFaq/NewFaq";
import ESCoinsDetail from "./es/CoinDetailsNew/CoinDetailsNew";
import ESFaq from "./es/Faq/Faq";
import ESLegal from "./es/Faq/Legal";
import ESTnc from "./es/Faq/Tnc";
import ESPrivacyPolicy from "./es/Faq/PrivacyPolicy";
import ESRewardpoints from "./es/Faq/Rewardpoints";
import ESGeneralQueries, {
  ESBaaziSelectMembership,
  ESBaaziStore,
  ESGameplayQueries,
  ESLeaderboardAndProgression,
  ESTaskRewards,
  ESTechnicalQueries,
  ESWallet,
} from "./es/Faq/GeneralQueries";
import ESTournamentRules from "./es/TournamentRules";

import PT from "./pt/PT";
import PTNewFaq from "./pt/NewFaq/NewFaq";
import PTCoinsDetail from "./pt/CoinDetailsNew/CoinDetailsNew";
import PTFaq from "./pt/Faq/Faq";
import PTLegal from "./pt/Faq/Legal";
import PTTnc from "./pt/Faq/Tnc";
import PTPrivacyPolicy from "./pt/Faq/PrivacyPolicy";
import PTRewardpoints from "./pt/Faq/Rewardpoints";
import PTGeneralQueries, {
  PTBaaziSelectMembership,
  PTBaaziStore,
  PTGameplayQueries,
  PTLeaderboardAndProgression,
  PTTaskRewards,
  PTTechnicalQueries,
  PTWallet,
} from "./pt/Faq/GeneralQueries";
import PTTournamentRules from "./pt/TournamentRules";

// const pages = [
//   "PokerSchoolComingSoon", "Howtoplay", "Howtoplay2", "Howtoplaynewuser",
//   "Howtoplaypokerpartnerapp", "Howtoplayplaycircle",
//   "Flash", "HowTournamentWork", "LeaderBoard", "Satelite", "PfsVideos",
//   "PokerSchool", "TestingHeader", "TestingNoHeader",
//   "MonsoonCarnival", "BaaziTurbo", "Baazi1000x", "IndianPokerMasters",
//   "IndianPokerMastersBackup", "EndBoss",
//   "Imps", "SuperHoldem", "FtdBonus", "MoneyMaker", "MissionMarathon",
//   "Goatold", "PokerGo", "Shahid", "ShahidNew", "Mythbuster", "SitandGo", "SitandGoMCE",
//   "PloVideos", "DepositWithdrawFaq", "BaaziValueSeries", "Anniversary9th", "FreeEntry",
//   "FaqGst", "Classics", "Tschedule", "NpsBootCamp",
//   "Bss", "PokerBaazi4", "CashBattleRoyale6", "Aptindia",
//   "Allinfold", "Helpdesk", "MobileAppPaymentSuccess", "OfcRewardFaq", "BaaziMillions",
//   "FaqGuestPreLogin", "FaqDeposit", "MasterClass", "RakeWork", "PowerSaving"

// ].reduce((acc, page) => {
//   acc[page] = React.lazy(() => import(`./pages/${page}`));
//   return acc;
// }, {});

// const Promotions = React.lazy(() => import("./Promotions"));
// const Homepage = React.lazy(() => import("./dsite/pages/Homepage"));
// const VietnamScoreCard = React.lazy(() => import("./pages/VietnamTournamentPage/VietnamScoreCard"));
// const Fairplay = React.lazy(() => import("./pages/FairplayPage/Fairplay"));
// const Allinclub = React.lazy(() => import("./pages/AllinclubPage/Allinclub"));
// const Anniversary10th = React.lazy(() => import("./pages/Anniversary10th/Anniversary10th"));
// const Series1000x = React.lazy(() => import("./pages/Series1000xPage/Series1000x"));
// const Cashanniversary = React.lazy(() => import("./pages/CashanniversaryPage/Cashanniversary"));
// const Wintercashcarnival = React.lazy(() => import("./pages/WintercashcarnivalPage/Wintercashcarnival"));
// const Newyearcashcarnival = React.lazy(() => import("./pages/NewyearcashcarnivalPage/Newyearcashcarnival"));
// const Springcashcarnival = React.lazy(() => import("./pages/SpringcashcarnivalPage/Springcashcarnival"));
// const Summercashcarnival = React.lazy(() => import("./pages/SummercashcarnivalPage/Summercashcarnival"));
// const Anniversarycarnival = React.lazy(() => import("./pages/AnniversarycarnivalPage/Anniversarycarnival"));

// const Bombpot = React.lazy(() => import("./pages/BombpotPage/Bombpot"));
// const Wpt = React.lazy(() => import("./pages/WPTPage/WPT"));
// const TeamPro = React.lazy(() => import("./pages/TeamProPage/TeamPro"));
// const Nps = React.lazy(() => import("./pages/NpsSeries/Nps"));
// const NpsTnc = React.lazy(() => import("./pages/NpsSeries/NpsTnc"));
// const NpsLeaderboard = React.lazy(() => import("./pages/NpsSeries/NpsLeaderboard"));
// const NpsSchedule = React.lazy(() => import("./pages/NpsSeries//NpsSchedule"));
// const NpChampion = React.lazy(() => import("./pages/NpsSeries/NpChampion"));
// const NpsInfo = React.lazy(() => import("./pages/NpsSeries/NpsInfo"));
// const Npctnc = React.lazy(() => import("./pages/NpsSeries/Npctnc"));
// const HowItWorksNpc = React.lazy(() => import("./pages/NpsSeries/HowItWorksNpc"));
// const HowItWorksNpcDsite = React.lazy(() => import("./dsite/pages/HowItWorksNpc/HowItWorksNpcDsite"));

// const Roadtonps = React.lazy(() => import("./pages/RoadToNpsPage/RoadToNps"));
// const PlayerOfTheYear = React.lazy(() => import("./pages/PlayeroftheyearPage/PlayerOfTheYear"));
// const TncPoy = React.lazy(() => import("./pages/PlayeroftheyearPage/TncPoy"));
// const TncAllinclub = React.lazy(() => import("./pages/AllinclubPage/TncAllinclub"));
// const Npscamp = React.lazy(() => import("./pages/NpsCampPage/Npscamp"));
// const NpsAllTimeRanking = React.lazy(() => import("./pages/NpsAllTimeRankingPage/NpsAllTimeRanking"));
// const PlayerDetails = React.lazy(() => import("./pages/NpsAllTimeRankingPage/PlayerDetails"));
// const Mytickets = React.lazy(() => import("./pages/MyticketsPage/Mytickets"));
// const Thecircuit = React.lazy(() => import("./pages/ThecircuitPage/Thecircuit"));
// const Productupdate = React.lazy(() => import("./pages/ProductupdatePage/Productupdate"));
// const Whatisplo = React.lazy(() => import("./pages/WhatisploPage/Whatisplo"));
// const Goatnew = React.lazy(() => import("./pages/GoatPage/Goat"));
// const TDSPolicy = React.lazy(() => import("./pages/TdsPolicyPage/TDSPolicy"));

export default function AllRouting() {
  return (
    <BrowserRouter>
      <Suspense fallback={<div className="text-centered"></div>}>
        <Routes>
          {/* {Object.entries(pages).map(([name, Component]) => (
            <Route key={name} path={`/${name.toLowerCase()}`} element={<Component />} />
          ))} */}
          {/* <Route path="/homepage" element={<Homepage />} />
          <Route path="/" element={<Promotions />} />
          <Route path="/vietnamscorecard" element={<VietnamScoreCard />} />
          <Route path="/fairplay" element={<Fairplay />} />
          <Route path="/allinclub" element={<Allinclub />} />
          <Route path="/mytickets" element={<Mytickets />} />
          <Route path="/thecircuit" element={<Thecircuit />} />
          <Route path="/productupdates" element={<Productupdate />} />
          <Route path="/whatisplo" element={<Whatisplo />} />
          <Route path="/goat" element={<Goatnew/>} />
          <Route path="/anniversary10th" element={<Anniversary10th />} />
          <Route path="/series1000x" element={<Series1000x />} />
          <Route path="/cash-anniversary" element={<Cashanniversary />} />
          <Route path="/wintercashcarnival" element={<Wintercashcarnival />} />
          <Route path="/newyearcashcarnival" element={<Newyearcashcarnival />} />
          <Route path="/springcashcarnival" element={<Springcashcarnival />} />
          <Route path="/summercashcarnival" element={<Summercashcarnival />} />
          <Route path="/anniversarycashcarnival" element={<Anniversarycarnival/>} />
          <Route path="/bombpot" element={<Bombpot />} />
          <Route path="/wpt" element={<Wpt />} />
          <Route path="/teampro" element={<TeamPro />} />
          <Route path="/nps" element={<Nps />} />
          <Route path="/npstnc" element={<NpsTnc />} />
          <Route path="/npsleaderboard" element={<NpsLeaderboard />} />
          <Route path="/npsschedule" element={<NpsSchedule />} />
          <Route path="/npchampion" element={<NpChampion />} />
          <Route path="/npsinfo" element={<NpsInfo />} />
          <Route path="/npctnc" element={<Npctnc />} />
          <Route path="/howitworksnpc" element={<HowItWorksNpc />} />
          <Route path="/howitworksnpcdsite" element={<HowItWorksNpcDsite />} />

          <Route path="/roadtonps" element={<Roadtonps />} />
          <Route path="/playeroftheyear" element={<PlayerOfTheYear />} />
          <Route path="/tncpoy" element={<TncPoy />} />
          <Route path="/allinclub/tnc" element={<TncAllinclub />} />
          <Route path="/npscamp" element={<Npscamp />} />
          <Route path="/npsalltimeranking" element={<NpsAllTimeRanking />} />
          <Route path="/tdspolicy" element={<Navigate to="/tds-free-april" replace />} />
          <Route path="/tds-free-april" element={<TDSPolicy />} />
          <Route path="/ftp-privacy-policy" element={<PrivacyPloicy/> } /> */}

          <Route path="/tournament-rules" element={<TournamentRules />} />
          <Route path="/faq" element={<NewFaq />} />
          <Route path="/faqs" element={<Faq />} />
          <Route path="/faqs/legality" element={<Legal />} />
          <Route path="/faqs/tnc" element={<Tnc />} />
          <Route path="/faqs/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/faqs/general-queries" element={<GeneralQueries />} />
          <Route path="/faqs/rewards-points" element={<Rewardpoints />} />
          <Route
            path="/faqs/leaderboard-and-progression"
            element={<LeaderboardAndProgression />}
          />
          <Route path="/faqs/gameplay-queries" element={<GameplayQueries />} />
          <Route path="/faqs/baazi-store" element={<BaaziStore />} />
          <Route
            path="/faqs/baazi-select-membership"
            element={<BaaziSelectMembership />}
          />
          <Route path="/faqs/task-rewards" element={<TaskRewards />} />
          <Route
            path="/faqs/technical-queries"
            element={<TechnicalQueries />}
          />
          <Route path="/faqs/wallet" element={<Wallet />} />
          <Route path="/CoinsDetail" element={<CoinDetailsNew />} />

          <Route path="*" element={<NotFound />} />
          {/* <Route path="/playerdetails" element={<PlayerDetails/>} /> */}
          {/* <Route path="/" element={<NpsAllTimeRanking/>} /> */}
          {/* {leaderboardData.map((index) => (
            <Route key={index} path={`/npsalltimeranking/:fullName`} element={<PlayerDetails />} />
          ))} */}

          <Route path="/" element={<EN />} />

          <Route path="/ph" element={<PH />} />
          <Route path="/ph/faq" element={<PHNewFaq />} />
          <Route path="/ph/CoinsDetail" element={<PHCoinsDetail />} />

          <Route path="/ph/faqs" element={<PHFaq />} />
          <Route path="/ph/faqs/legality" element={<PHLegal />} />
          <Route path="/ph/faqs/tnc" element={<PHTnc />} />
          <Route path="/ph/faqs/privacy-policy" element={<PHPrivacyPolicy />} />
          <Route
            path="/ph/faqs/general-queries"
            element={<PHGeneralQueries />}
          />
          <Route path="/ph/faqs/rewards-points" element={<PHRewardpoints />} />
          <Route
            path="/ph/faqs/leaderboard-and-progression"
            element={<PHLeaderboardAndProgression />}
          />
          <Route
            path="/ph/faqs/gameplay-queries"
            element={<PHGameplayQueries />}
          />
          <Route path="/ph/faqs/baazi-store" element={<PHBaaziStore />} />
          <Route
            path="/ph/faqs/baazi-select-membership"
            element={<PHBaaziSelectMembership />}
          />
          <Route path="/ph/faqs/task-rewards" element={<PHTaskRewards />} />
          <Route
            path="/ph/faqs/technical-queries"
            element={<PHTechnicalQueries />}
          />
          <Route path="/ph/faqs/wallet" element={<PHWallet />} />
          <Route path="/ph/tournament-rules" element={<PHTournamentRules />} />

          <Route path="/es" element={<ES />} />
          <Route path="/es/faq" element={<ESNewFaq />} />
          <Route path="/es/CoinsDetail" element={<ESCoinsDetail />} />
          <Route path="/es/faqs" element={<ESFaq />} />
          <Route path="/es/faqs/legality" element={<ESLegal />} />
          <Route path="/es/faqs/tnc" element={<ESTnc />} />
          <Route path="/es/faqs/privacy-policy" element={<ESPrivacyPolicy />} />
          <Route path="/es/faqs/general-queries" element={<ESGeneralQueries />} />
          <Route path="/es/faqs/rewards-points" element={<ESRewardpoints />} />
          <Route path="/es/faqs/leaderboard-and-progression" element={<ESLeaderboardAndProgression />} />
          <Route path="/es/faqs/gameplay-queries" element={<ESGameplayQueries />} />
          <Route path="/es/faqs/baazi-store" element={<ESBaaziStore />} />
          <Route path="/es/faqs/baazi-select-membership" element={<ESBaaziSelectMembership />} />
          <Route path="/es/faqs/task-rewards" element={<ESTaskRewards />} />
          <Route path="/es/faqs/technical-queries" element={<ESTechnicalQueries />} />
          <Route path="/es/faqs/wallet" element={<ESWallet />} />
          <Route path="/es/tournament-rules" element={<ESTournamentRules />} />

          <Route path="/pt" element={<PT />} />
          <Route path="/pt/faq" element={<PTNewFaq />} />
          <Route path="/pt/CoinsDetail" element={<PTCoinsDetail />} />
          <Route path="/pt/faqs" element={<PTFaq />} />
          <Route path="/pt/faqs/legality" element={<PTLegal />} />
          <Route path="/pt/faqs/tnc" element={<PTTnc />} />
          <Route path="/pt/faqs/privacy-policy" element={<PTPrivacyPolicy />} />
          <Route path="/pt/faqs/general-queries" element={<PTGeneralQueries />} />
          <Route path="/pt/faqs/rewards-points" element={<PTRewardpoints />} />
          <Route path="/pt/faqs/leaderboard-and-progression" element={<PTLeaderboardAndProgression />} />
          <Route path="/pt/faqs/gameplay-queries" element={<PTGameplayQueries />} />
          <Route path="/pt/faqs/baazi-store" element={<PTBaaziStore />} />
          <Route path="/pt/faqs/baazi-select-membership" element={<PTBaaziSelectMembership />} />
          <Route path="/pt/faqs/task-rewards" element={<PTTaskRewards />} />
          <Route path="/pt/faqs/technical-queries" element={<PTTechnicalQueries />} />
          <Route path="/pt/faqs/wallet" element={<PTWallet />} />
          <Route path="/pt/tournament-rules" element={<PTTournamentRules />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
